import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { messages } from './messages';
import { Button } from '../../button';

import { openAddSalesOrderToBatchFromOrdersGrid } from '../../../../store/orders/grid/orders.grid.header.actions';

import style from './index.module.less';

export const GroupbyActionPopover = ({ hasSelectedSpilloverItems }) => {
  const dispatch = useDispatch();
  const addToBatch = useCallback(() => dispatch(openAddSalesOrderToBatchFromOrdersGrid()), [dispatch]);

  return (
    <div className={style['groupby-action-popover-body']}>
      {!hasSelectedSpilloverItems && (
        <Button
          className={style['groupby-action-popover-item']}
          onClick={addToBatch}
          pendoTrackingId='/orders#group-by-add-to-batch'
          theme='unstyled'
        >
          <FormattedMessage {...messages.groupOrdersAddToBatch} />
        </Button>
      )}
    </div>
  );
};

GroupbyActionPopover.propTypes = {
  groupByDetails: PropTypes.array.isRequired,
  hasSelectedSpilloverItems: PropTypes.bool.isRequired,
};
